<script>
import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'

// penanda disimpan di cookie karena localStorage dibersihkan setiap login/logout
const COOKIE_PANDUAN = 'guideline_aktivitas'

// panduan yang menyorot langsung komponen baru pada halaman input aktivitas
export default {
  data: () => ({
    tur:null,
    timer:null,
  }),

  mounted(){
    if (!this.sudahDilihat()){
      // tunggu halaman selesai dirender agar posisi sorotan tepat
      this.timer = setTimeout(this.mulai, 600)
    }
  },

  beforeDestroy(){
    clearTimeout(this.timer)
    if (this.tur){
      this.tur.destroy()
    }
  },

  render(){
    return null
  },

  methods:{
    sudahDilihat(){
      try{
        return document.cookie.split('; ').indexOf(COOKIE_PANDUAN + '=1') != -1
      } catch (e){
        return false
      }
    },

    tandaiDilihat(){
      try{
        // berlaku 5 tahun
        document.cookie = COOKIE_PANDUAN + '=1; max-age=' + (60*60*24*365*5) + '; path=/'
      } catch (e){
        // abaikan, panduan akan tampil lagi pada kunjungan berikutnya
      }
    },

    judul(icon, color, teks){
      let warna = this.$vuetify.theme.currentTheme[color]
      return '<span class="panduan-ikon" style="background-color:' + warna + '"><i class="mdi ' + icon + '"></i></span>' + teks
    },

    isi(teks, poin){
      let baris = (poin || []).map(x => {
        let warna = this.$vuetify.theme.currentTheme[x.color]
        return '<div class="panduan-poin"><i class="mdi ' + x.icon + '" style="color:' + warna + '"></i><span>' + x.teks + '</span></div>'
      })
      return '<p>' + teks + '</p>' + baris.join('')
    },

    mulai(){
      // tampilkan tab laporan agar bisa disorot
      this.$emit('mulai')

      this.tur = driver({
        showProgress:true,
        progressText:'{{current}} dari {{total}}',
        nextBtnText:'Lanjut',
        prevBtnText:'Kembali',
        doneBtnText:'Mengerti',
        popoverClass:'panduan-popover',
        overlayOpacity:0.6,
        stagePadding:6,
        stageRadius:8,
        steps:[
          {
            element:'#panduan-kalender',
            popover:{
              title:this.judul('mdi-calendar-cursor', 'primary', 'Pilih Tanggal'),
              description:this.isi('Klik tanggal di kalender untuk melihat laporannya.'),
            }
          },
          {
            element:'#panduan-tab-laporan',
            popover:{
              title:this.judul('mdi-file-chart', 'info', 'Baru: Tab Laporan'),
              description:this.isi('Semua laporan pada tanggal yang dipilih ada di sini.'),
            }
          },
          {
            element:'#panduan-laporan',
            popover:{
              title:this.judul('mdi-format-list-checks', 'info', 'Detail & Status Laporan'),
              description:this.isi('Pantau hasil verifikasi setiap laporan.', [
                {icon:'mdi-timer-sand', color:'info', teks:'<b>Diproses</b> &ndash; menunggu verifikasi'},
                {icon:'mdi-check-circle', color:'success', teks:'<b>Disetujui</b> verifikator'},
                {icon:'mdi-close-circle', color:'error', teks:'<b>Ditolak</b> &ndash;'},
              ]),
            }
          },
          {
            element:'#panduan-verifikator',
            popover:{
              title:this.judul('mdi-account-check', 'success', 'Baru: Verifikator Aktivitas'),
              description:this.isi('Tentukan siapa yang memverifikasi aktivitas Anda.', [
                {icon:'mdi-account', color:'primary', teks:'<b>Atasan</b> &ndash; cari dengan NIP'},
                {icon:'mdi-account-tie', color:'primary', teks:'<b>PLT</b> &ndash; cari dengan ID Jabatan'},
                {icon:'mdi-pencil', color:'primary', teks:'Bisa diubah kapan saja'},
              ]),
            }
          },
        ],
        onDestroyed:() => {
          this.tur = null
          this.tandaiDilihat()
        }
      })

      this.tur.drive()
    }
  }
}
</script>

<style lang="scss">
  @import '~@/sass/panduan.scss';
</style>
